"use strict";function getItem$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getItem$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="util.domainStorage.getItem";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.9.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.9.0"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.6.29"},_a)),exports.getItem$=getItem$,exports.default=getItem$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/util/domainStorage/getItem.js
// module id = 1103
// module chunks = 106